import { LabelGenerator } from '../../types';

export const isKeineQuellensteuer: LabelGenerator = (product) =>
  product.deposit_taking_bank.branch_country.source_tax_applicable === false &&
  product.deposit_taking_bank.branch_country.domestic_taxation_applicable === false &&
  'KeineQuellensteuer';
